/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLastOpenShiftMovements200ResponseMovementsInner } from './GetLastOpenShiftMovements200ResponseMovementsInner';
import {
    GetLastOpenShiftMovements200ResponseMovementsInnerFromJSON,
    GetLastOpenShiftMovements200ResponseMovementsInnerFromJSONTyped,
    GetLastOpenShiftMovements200ResponseMovementsInnerToJSON,
    GetLastOpenShiftMovements200ResponseMovementsInnerToJSONTyped,
} from './GetLastOpenShiftMovements200ResponseMovementsInner';

/**
 * 
 * @export
 * @interface GetLastOpenShiftMovements200Response
 */
export interface GetLastOpenShiftMovements200Response {
    /**
     * 
     * @type {Array<GetLastOpenShiftMovements200ResponseMovementsInner>}
     * @memberof GetLastOpenShiftMovements200Response
     */
    movements: Array<GetLastOpenShiftMovements200ResponseMovementsInner>;
}

/**
 * Check if a given object implements the GetLastOpenShiftMovements200Response interface.
 */
export function instanceOfGetLastOpenShiftMovements200Response(value: object): value is GetLastOpenShiftMovements200Response {
    if (!('movements' in value) || value['movements'] === undefined) return false;
    return true;
}

export function GetLastOpenShiftMovements200ResponseFromJSON(json: any): GetLastOpenShiftMovements200Response {
    return GetLastOpenShiftMovements200ResponseFromJSONTyped(json, false);
}

export function GetLastOpenShiftMovements200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLastOpenShiftMovements200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'movements': ((json['movements'] as Array<any>).map(GetLastOpenShiftMovements200ResponseMovementsInnerFromJSON)),
    };
}

export function GetLastOpenShiftMovements200ResponseToJSON(json: any): GetLastOpenShiftMovements200Response {
    return GetLastOpenShiftMovements200ResponseToJSONTyped(json, false);
}

export function GetLastOpenShiftMovements200ResponseToJSONTyped(value?: GetLastOpenShiftMovements200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'movements': ((value['movements'] as Array<any>).map(GetLastOpenShiftMovements200ResponseMovementsInnerToJSON)),
    };
}

